export default {
  orgActivity: {
    title: "Actividad",
    subtitle: "Quién ha hecho qué en tu organización.",
    export: "Exportar CSV",
    retentionNote: "Mostrando los últimos {days} días. El histórico completo está disponible en los planes PRO y ULTRA.",
    allActions: "Todas las acciones",
    from: "Desde",
    to: "Hasta",
    clear: "Limpiar",
    loading: "Cargando…",
    empty: "Aún no hay actividad registrada en tu organización.",
    emptyFilters: "Sin actividad con los filtros actuales.",
    eventsCount: "{n} eventos",
    colDateTime: "Fecha/Hora",
    colUser: "Usuario",
    colAction: "Acción",
    colDetail: "Detalle",
    colIp: "IP",
    prev: "← Anterior",
    next: "Siguiente →",
    pageOf: "Pág. {page} de {total}",
  },
};
